import Popper from 'popper.js';
import React from 'react';
import {UncontrolledTooltip} from 'reactstrap';

type Props = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> &
  {
    tooltipText: React.ReactNode;
    tooltipPlacement?: Popper.Placement
  }

export class TooltipDiv extends React.Component<Props> {
  readonly spanRef = React.createRef<HTMLDivElement>();

  render() {
    const spanRef = this.spanRef;
    const {tooltipText, tooltipPlacement, children, ...rest} = this.props;
    return (
      <>
        <div ref={spanRef}
             {...rest}>
          {children}
        </div>
        <UncontrolledTooltip target={spanRef}
                             placement={tooltipPlacement}>
          {tooltipText}
        </UncontrolledTooltip>
      </>);
  }
}
